import { createRouter, createWebHistory } from 'vue-router';
import { takeSessionExpired } from '../utils/session_expiry';
import Home from '../views/HomePage.vue';
import Login from '../views/LoginPage.vue';
import UpgradePage from '../views/UpgradePage.vue';
import RegisterPage from '../views/RegisterPage.vue';
import ResetPassword from '../views/ResetPasswordPage.vue';
import ChooseNewPassword from '../views/ChooseNewPassword.vue';
import SettingsPage from '../views/SettingsPage.vue';
import LeaderboardsPage from '../views/Leaderboard/LeaderboardsPage.vue';
import LeaderboardPage from '../views/Leaderboard/LeaderboardPage.vue';
import TeamPage from '../views/TeamPage.vue';
import TeamInvitePage from '../views/TeamInvitePage.vue';
import RedeemPage from '../views/RedeemPage.vue';
import FriendCodesPage from '../views/FriendCodesPage.vue';
import AcademyPage from '../views/AcademyPage.vue';
import BlastPage from '../views/BlastPage.vue';
import SteamLinkErrorPage from '../views/SteamLinkErrorPage.vue';
import CommunityHubPage from '../views/CommunityHub/CommunityHubPage.vue';
import CustomContentPage from '../views/CommunityHub/CustomContentPage.vue';
import UserProfile from '../views/UserProfilePage.vue';
import ServerManagerPage from '../views/ServerManagerPage.vue';
import UtilityHubPage from '../views/UtilityHubPage.vue';
import TrackWarmupPage from '../views/Public/TrackWarmup.vue';
import JoinPage from '../views/Public/JoinPage.vue';
import LanPartyPage from '../views/LanPartyPage.vue';
import LanControlRoomPage from '../views/LanControlRoomPage.vue';
import LanHubPage from '../views/LanHubPage.vue';
import TwitchCallbackPage from '../views/TwitchCallbackPage.vue';
import CommunityServersPage from '../views/CommunityServersPage.vue';
import DemoViewerPage from '../views/DemoViewerPage.vue';
import DemoViewerUpgradePage from '../views/DemoViewerUpgradePage.vue';
import BootcampsPage from '../views/Bootcamp/BootcampsPage.vue';
import BootcampPage from '../views/Bootcamp/BootcampPage.vue';
import BootcampExamPage from '../views/Bootcamp/BootcampExamPage.vue';
import RoutinesPage from '../views/Routines/RoutinesPage.vue';
import MatchmakingPage from '../views/MatchmakingPage.vue';
import MatchmakingLobbyPage from '../views/MatchmakingLobbyPage.vue';
import RoutinePage from '../views/Routines/RoutinePage.vue';
// import HighlightPage from "../views/HighlightPage.vue" // Allstar highlights disabled
import ChangeEmailPage from '../views/ChangeEmailPage.vue';
import UpgradeStatusPage from '../views/UpgradeStatusPage.vue';
import BootcampExamSharePage from '../views/Bootcamp/BootcampExamSharePage.vue';
import RoutineEditPage from '../views/Routines/RoutineEditPage.vue';
import DemoPage from '../views/DemoPage.vue';
import LibraryPage from '../views/LibraryPage.vue';
import ClaimTrialPage from '../views/ClaimTrialPage.vue';
import PlayNowPage from '../views/PlayNowPage.vue';
import ProSeries from '../components/Matches/lists/ProSeries.vue';
import MyCoachRoutinePage from '../views/Routines/MyCoachRoutinePage.vue';
import MatchesPage from '../views/Coach/MatchesPage.vue';
import MatchPage from '../views/Coach/MatchPage.vue';
import CoachPage from '../views/Coach/CoachPage.vue';
import TrainingSessionsPage from '../views/TrainingSessions/TrainingSessionsPage.vue';
import TrainingSessionDetailsPage from '../views/TrainingSessions/TrainingSessionDetailsPage.vue';
import { v5Routes } from '../v5/routes';

// Exported so tests can resolve paths against the real table without booting the app.
export const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Home,
    meta: {
      auth: true,
    },
  },
  {
    path: '/user/:uuid',
    name: 'UserProfile',
    component: UserProfile,
    meta: {
      auth: true,
    },
  },
  {
    path: '/team',
    name: 'Team',
    component: TeamPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/team_invites/:token',
    name: 'Team Invite',
    component: TeamInvitePage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/claim_trial/:source',
    name: 'ClaimTrial',
    component: ClaimTrialPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      auth: false,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage,
    meta: {
      auth: false,
    },
  },
  {
    path: '/reset_password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      auth: false,
    },
  },
  {
    path: '/change_email/:token',
    name: 'ChangeEmail',
    component: ChangeEmailPage,
  },
  {
    path: '/choose_new_password',
    name: 'ChooseNewPassword',
    component: ChooseNewPassword,
    meta: {
      auth: false,
    },
  },
  {
    path: '/matches',
    name: 'MatchesPage',
    component: MatchesPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/play',
    name: 'PlayNowPage',
    component: PlayNowPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/demo_viewer_upgrade',
    name: 'DemoViewerUpgrade',
    component: DemoViewerUpgradePage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/upgrade_status',
    name: 'UpgradeStatus',
    component: UpgradeStatusPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/library',
    name: 'LibraryPage',
    component: LibraryPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/community_hub/:type',
    name: 'CommunityHubPage',
    component: CommunityHubPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/community_hub/custom_sets/:id',
    name: 'CustomSetPage',
    component: CustomContentPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/community_hub/grenade_groups/:id',
    name: 'GrenadeGroupPage',
    component: CustomContentPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/community_hub/strategy/:id',
    name: 'StrategyPage',
    component: CustomContentPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/community_hub/vpl/:id',
    name: 'VplPage',
    component: CustomContentPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/matches/:id',
    name: 'MatchPage',
    component: MatchPage,
  },
  {
    path: '/matches/pro_series/:id',
    name: 'ProSeriesPage',
    component: ProSeries,
  },
  {
    path: '/demos/:id',
    name: 'DemoPage',
    component: DemoPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/bootcamp',
    name: 'BootcampsPage',
    component: BootcampsPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/matchmaking',
    name: 'MatchmakingPage',
    component: MatchmakingPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/join/:slug',
    name: 'JoinPage',
    component: JoinPage,
    // No auth meta: signed-out and signed-in viewers both land here (auth: false is guests only).
  },
  {
    path: '/twitch/callback',
    name: 'TwitchCallbackPage',
    component: TwitchCallbackPage,
    // No auth meta: a session lost on Twitch must not push the code through the login page.
  },
  {
    path: '/lan',
    name: 'LanHubPage',
    component: LanHubPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/lan/:slug',
    name: 'LanPartyPage',
    component: LanPartyPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/matchmaking/lan',
    name: 'MatchmakingLanPage',
    component: MatchmakingPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/matchmaking/lan/:slug/control-room',
    name: 'LanControlRoomPage',
    component: LanControlRoomPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/matchmaking/lobby/:id',
    name: 'MatchmakingLobbyPage',
    component: MatchmakingLobbyPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/routines',
    name: 'RoutinesPage',
    component: RoutinesPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/coach/:name', // cf src/utils/coach_routines.js
    name: 'CoachRoutinePage',
    component: RoutinePage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/routines/:slug',
    name: 'RoutinePage',
    component: RoutinePage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/routines/:slug/edit',
    name: 'RoutineEditPage',
    component: RoutineEditPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/bootcamp/:slug',
    name: 'BootcampPage',
    component: BootcampPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/bootcamp/:slug/exam/:difficulty',
    name: 'BootcampExamPage',
    component: BootcampExamPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/bootcamp/:slug/share_exam/:id',
    name: 'BootcampExamSharePage',
    component: BootcampExamSharePage,
  },
  {
    path: '/upgrade',
    name: 'UpgradePage',
    component: UpgradePage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/redeem',
    name: 'Redeem',
    component: RedeemPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/friend_codes',
    alias: ['/trial_codes', '/trialcodes'],
    name: 'FriendCodesPage',
    component: FriendCodesPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/settings',
    name: 'SettingsPage',
    component: SettingsPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/leaderboards',
    name: 'Leaderboards',
    component: LeaderboardsPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/leaderboards/:uuid',
    name: 'LeaderboardPage',
    component: LeaderboardPage,
  },
  {
    path: '/academy/videos/:slug',
    name: 'VideoPage',
    component: AcademyPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/academy',
    name: 'AcademyPage',
    component: AcademyPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/blast',
    name: 'BlastPage',
    component: BlastPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/server_manager',
    name: 'ServerManagerPage',
    component: ServerManagerPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/utility_hub',
    name: 'UtilityHubPage',
    component: UtilityHubPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/callouts',
    name: 'CalloutsPage',
    component: () => import('../views/CalloutsPage.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/community_servers',
    name: 'CommunityServersPage',
    component: CommunityServersPage,
  },
  // Allstar highlights disabled
  // {
  //     path: '/highlights/:uuid',
  //     name: 'HighlightPage',
  //     component: HighlightPage,
  // },
  {
    path: '/demos/:id/review',
    name: 'ReviewPage',
    component: DemoViewerPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/matches/:uuid/review',
    name: 'MatchReviewPage',
    component: DemoViewerPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/coach',
    name: 'CoachPage',
    component: CoachPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/steam-link-error',
    name: 'Steam Link Error',
    component: SteamLinkErrorPage,
    meta: {
      auth: true,
    },
  }, {
    path: '/high_scores/public_warmup',
    name: 'Public Warmup',
    component: () => import('../views/Public/WarmupScores.vue'),
    meta: {
      auth: false,
    },
  },
  {
    path: '/track_warmup_usage/:steam_id',
    name: 'Track Warmup',
    component: TrackWarmupPage,
    meta: {
      auth: false,
    },
  },
  {
    path: '/steam/callback',
    name: 'SteamCallback',
    component: () => import('../views/SteamCallback.vue'),
    meta: {
      auth: false,
    },
  },
  {
    path: '/routines/coach',
    name: 'CoachRoutinesPage',
    component: MyCoachRoutinePage,
    meta: {
      auth: true,
    },
  },
  // The rsparse coach pages moved onto the regular paths, which now switch per
  // user. These redirects keep old links working and, just as importantly, stop
  // /coach/matches and /coach/profile falling through to /coach/:name — with no
  // route of their own they would quietly render CoachRoutinePage instead of
  // erroring, since a routine slug is just a param.
  {
    path: '/coach/matches',
    redirect: { name: 'MatchesPage' },
  },
  {
    path: '/coach/matches/:id',
    redirect: (to) => ({ name: 'MatchPage', params: { id: to.params.id } }),
  },
  {
    path: '/coach/profile',
    redirect: { name: 'CoachPage' },
  },
  {
    path: '/sessions',
    name: 'TrainingSessionsPage',
    component: TrainingSessionsPage,
    meta: {
      auth: true,
    },
  },
  {
    path: '/sessions/:uuid',
    name: 'TrainingSessionDetailsPage',
    component: TrainingSessionDetailsPage,
    meta: {
      auth: true,
    },
  },
  // The v5 redesign, admin only for now (src/v5/access.js)
  ...v5Routes,
  { path: '/:pathMatch(.*)*', redirect: '/' },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// vue-auth signs an expired session out with a plain push to /login, which leaves no
// redirectedFrom: carry the page the player was on so the login can return there. A deliberate
// logout takes the same push; it gets no ?redirect=, or the next person to sign in on this browser
// would land on the previous user's page.
export function returnAfterExpiry(to, from) {
  if (to.name === 'Login' && from.meta.auth && !to.redirectedFrom && !to.query.redirect
    && takeSessionExpired()) {
    return { name: 'Login', query: { ...to.query, redirect: from.fullPath } };
  }
  return true;
}
router.beforeEach(returnAfterExpiry);

export default router;
